/* unplugin-vue-components disabled */import { render } from "./agent-output.vue?vue&type=template&id=fda8cd72&scoped=true"
import script from "./agent-output.vue?vue&type=script&lang=js"
export * from "./agent-output.vue?vue&type=script&lang=js"

import "./agent-output.vue?vue&type=style&index=0&id=fda8cd72&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fda8cd72"],['__file',"src/pages/settings/admin/test-agents/agent-output.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fda8cd72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fda8cd72', __exports__)) {
    api.reload('fda8cd72', __exports__)
  }
  
  module.hot.accept("./agent-output.vue?vue&type=template&id=fda8cd72&scoped=true", () => {
    api.rerender('fda8cd72', render)
  })

}


export default __exports__